import { hyperdbHandlers } from 'hyperdb-utils';

export default hyperdbHandlers({ namespace: 'CUSTOMER' });



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/customer/handlers.js